/**
 *
 * Asynchronously loads the component for DriverHandoverV2
 *
 */

import Loadable from 'react-loadable'
import { LoadingIndicator } from '@app/components/LoadingIndicator'
import React from 'react'

export default Loadable({
  loader: () => import('./index'),
  loading: () => <LoadingIndicator />
})
